import { Breadcrumb, Flex, Space } from "antd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";

const BeCashBackOffice = ({
    menu = () => { },
    transactionTable = () => { },
    statusChangeModal = () => { }
}) => {
    const { t } = useTranslation();

    return (
        <MainLayout>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("welfare_loan.header") },
                    ]} />
                    <h2>{t("welfare_loan.header")}</h2>
                </Flex>
                <Flex vertical style={{ rowGap: "3vh" }}>
                    {menu()}
                    {transactionTable()}
                    {statusChangeModal()}
                </Flex>
            </Space>
        </MainLayout>
    )
}

export default BeCashBackOffice;